// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    gs: This.GoalSetting;
    goals: This.GoalSettingGoal[];
    goalType: This.GoalSettingGoalType;
    viewMode: This.GoalSettingViewMode;
    columnVisibility: This.GoalSettingGoalColumnVisibility;
    validateMinGoals: number;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingGoalsInclude',
    templateUrl: './GoalSettingGoalsInclude.html',
    styleUrls: ['./GoalSettingGoalsInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingGoalsInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingGoalsInclude';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {
        27: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled } = $scope
                if (screen.goals.length >= screen.validateMinGoals || !screen.gs.status.employeeCanEdit) return undefined
                return {
                    error: `At least ${screen.validateMinGoals} ${screen.goalType.label}s are required`,
                    ruleId: `minGoals_${screen.goalType.label}`,
                }
            }],
            async: [],
        }
    };
    input_gs = input(undefined, { alias: 'gs' });
    var_gs = proxySignal<This.GoalSetting>(undefined as any);
    input_goals = input(undefined, { alias: 'goals' });
    var_goals = proxySignal<This.GoalSettingGoal[]>(undefined as any);
    input_goalType = input(undefined, { alias: 'goalType' });
    var_goalType = proxySignal<This.GoalSettingGoalType>(undefined as any);
    input_viewMode = input(undefined, { alias: 'viewMode' });
    var_viewMode = proxySignal<This.GoalSettingViewMode>(undefined as any);
    input_columnVisibility = input(undefined, { alias: 'columnVisibility' });
    var_columnVisibility = proxySignal<This.GoalSettingGoalColumnVisibility>(undefined as any);
    input_validateMinGoals = input(undefined, { alias: 'validateMinGoals' });
    var_validateMinGoals = proxySignal<number>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get gs() { return component.var_gs() },
                set gs(value: This.GoalSetting) { component.var_gs.set(value) },
                get goals() { return component.var_goals() },
                set goals(value: This.GoalSettingGoal[]) { component.var_goals.set(value) },
                get goalType() { return component.var_goalType() },
                set goalType(value: This.GoalSettingGoalType) { component.var_goalType.set(value) },
                get viewMode() { return component.var_viewMode() },
                set viewMode(value: This.GoalSettingViewMode) { component.var_viewMode.set(value) },
                get columnVisibility() { return component.var_columnVisibility() },
                set columnVisibility(value: This.GoalSettingGoalColumnVisibility) { component.var_columnVisibility.set(value) },
                get validateMinGoals() { return component.var_validateMinGoals() },
                set validateMinGoals(value: number) { component.var_validateMinGoals.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            gs: this.screen.gs,
            goals: this.screen.goals,
            goalType: this.screen.goalType,
            viewMode: this.screen.viewMode,
            columnVisibility: this.screen.columnVisibility,
            validateMinGoals: this.screen.validateMinGoals
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_gs = this.dialogData?.data?.gs ?? this.input_gs() ?? (undefined)
            if (new_gs !== undefined) this.screen.gs = new_gs


            const new_goals = this.dialogData?.data?.goals ?? this.input_goals() ?? (undefined)
            if (new_goals !== undefined) this.screen.goals = new_goals


            const new_goalType = this.dialogData?.data?.goalType ?? this.input_goalType() ?? (undefined)
            if (new_goalType !== undefined) this.screen.goalType = new_goalType


            const new_viewMode = this.dialogData?.data?.viewMode ?? this.input_viewMode() ?? (undefined)
            if (new_viewMode !== undefined) this.screen.viewMode = new_viewMode


            const new_columnVisibility = this.dialogData?.data?.columnVisibility ?? this.input_columnVisibility() ?? (undefined)
            if (new_columnVisibility !== undefined) this.screen.columnVisibility = new_columnVisibility


            const new_validateMinGoals = this.dialogData?.data?.validateMinGoals ?? this.input_validateMinGoals() ?? (0)
            if (new_validateMinGoals !== undefined) this.screen.validateMinGoals = new_validateMinGoals

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_DropListBlock_13_cdkDropListDropped_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let event: Sys.Types.CdkDragDrop<any> = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    Sys.Data.transferArrayItem(screen.goals, screen.goals, event.previousIndex, event.currentIndex)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_20_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { goal, goalIndex, $disabled }: { goal: This.GoalSettingDevelopmentGoal, goalIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (confirm('Are you sure you want to delete this goal?'))
                        screen.goals.splice(goalIndex, 1)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_8_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.goals.push(new This.GoalSettingGoal)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
